

import { useState } from "react"
import { Stack, Card, CardContent, Typography, IconButton, Button } from "@mui/material";
import { grey } from '@mui/material/colors';
import { tendencyFormatter, timeRangeFormatter } from "../../../../utils/formatters";
import TendencyIcon from "../../../../components/TendencyIcon";
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useNavigate } from "react-router-dom"


const AnalysisCardItem = ({ insturmentIsin, label, currentValue, referenceValue, referenceTimeRange = null, unit = "%", handleRemoveAnalysisCard, chartRef }) => {

    const navigate = useNavigate()

    const variation = currentValue !== 0 ? ((currentValue - referenceValue) / currentValue) * 100 : 0
    const tendency = tendencyFormatter(variation)
    const tendencyColor = tendency === "up" ? "success.main" : tendency === "down" ? "error.main" : grey[600]

    const [intrumentPlotVisibiliity, setIntrumentPlotVisibiliity] = useState(true)

    const handleNavigateToBondDetail = () => {
        navigate(`/bond/${insturmentIsin}`)
    }

    const handlePlotVisibility = () => {
        const chart = chartRef.current
        if (!chart) return;

        const datasetIndex = chart.config._config.data.datasets.findIndex(ds => ds.label === label);
        if (datasetIndex === -1) return;

        const meta = chart.getDatasetMeta(datasetIndex);
        const isHidden = chart.data.datasets[datasetIndex].hidden
        meta.hidden = meta.hidden === null ? !isHidden : null;
        setIntrumentPlotVisibiliity(prev => !prev)
        chart.update();
    }

    return (
        <Card>
            <CardContent>
                <Stack justifyContent="space-between">
                    <Stack gap={2} direction="row" alignItems="flex-start" justifyContent="space-between">
                        <Button sx={{ textAlign: "left" }} variant="textSecondary" onClick={handleNavigateToBondDetail}>{label}</Button>
                        <Stack direction="row" gap={1} alignItems="center" justifyContent="flex-end">
                            <IconButton size="small" color="complementary" onClick={handlePlotVisibility}>{intrumentPlotVisibiliity ? <VisibilityIcon fontSize="inherit" /> : <VisibilityOffIcon fontSize="inherit" />}</IconButton>
                            <IconButton size="small" color="complementary" onClick={() => handleRemoveAnalysisCard(insturmentIsin)}><CloseIcon fontSize="inherit" /></IconButton>
                        </Stack>
                    </Stack>
                    <Typography variant="h4" fontWeight="bold">{unit === "₡" && unit}{currentValue.toFixed(2)}{unit === "%" && unit}</Typography>
                    <Stack direction="row" alignItems="center">
                        <Typography color={tendencyColor}>{variation > 0 && "+"}{variation.toFixed(2)}%</Typography>
                        <TendencyIcon tendency={tendency} />
                        <Typography color={tendencyColor}>{referenceTimeRange && timeRangeFormatter(referenceTimeRange)}.</Typography>
                    </Stack>
                </Stack >
            </CardContent>
        </Card >
    );
};

export default AnalysisCardItem;